import { createContext, FC, PropsWithChildren, useCallback, useMemo, useState } from "react";
import { IButtonProps } from "@gisce/oficina-virtual-components/dist/components/Button.component";

interface ISubmitButton {
  values: IButtonProps;
  setValues: (values: IButtonProps) => void;
};

export const SubmitButtonContext = createContext<ISubmitButton>({
  values: {}, 
  setValues: () => {}
});

const Contractation: FC<PropsWithChildren> = ({
  children
}) => {
  
  const [submitValues, setSubmitValues] = useState<IButtonProps>({});

  const handleSubmitValues: ISubmitButton["setValues"] = useCallback((values) => {
    setSubmitValues(values);
  }, []);

  const contextValue = useMemo(() => ({
    values: submitValues,
    setValues: handleSubmitValues
  }), [submitValues, handleSubmitValues]);
  
  return (
    <SubmitButtonContext.Provider value={contextValue}>
      {children}
    </SubmitButtonContext.Provider>
  );
};

export default Contractation;
